import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../lib/cn';

export type AlertProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  variant?: 'error' | 'info';
};

export function Alert({ className, children, variant = 'error', ...props }: AlertProps) {
  return (
    <div
      role="alert"
      className={cn(
        'border-2 border-brut-border px-3 py-2 text-sm',
        variant === 'error' && 'bg-brut-danger/10 text-brut-danger',
        variant === 'info' && 'bg-brut-bg text-brut-fg',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
